export default __webpack_public_path__ + "static/media/8.e0f1afa5.jpg";